module.exports = __webpack_public_path__ + "static/Stage_Logo-d4786315761338d83f68a6691f126e64.png";